import React from 'react';
import {Link, graphql} from 'gatsby';

import {PageProps} from '../types';
import Layout from '../components/layout';
import Seo from '../components/seo';

import '../styles/index.css';
import PostDates from '../components/post-dates';

const lang = 'ar';

type Props = PageProps & BlogIndexQueryResult;
function BlogIndex({location, data}: Props) {
	const siteTitle = data.site.siteMetadata.siteTitle[lang];
	const posts = data.allMarkdownRemark.edges;

	return (
		<Layout location={location} title={siteTitle} lang={lang}>
			<Seo
				title={`
                التدوينات
            `.trim()}
				lang={lang}
			/>

			<div className="Index">
				{posts.map(({node}) => {
					const title = node.frontmatter.title || node.fields.slug;
					return (
						<article key={node.fields.slug}>
							<header>
								<h3>
									<Link to={node.fields.slug}>{title}</Link>
								</h3>

								<small>
									<PostDates
										lang={lang}
										date={node.frontmatter.date}
										updated_at={node.frontmatter.updated_at}
									/>
								</small>
							</header>

							<p
								dangerouslySetInnerHTML={{
									__html:
										node.frontmatter.description ||
										node.excerpt,
								}}
							/>
						</article>
					);
				})}
			</div>
		</Layout>
	);
}

export default BlogIndex;

interface BlogIndexQueryResult {
	data: {
		site: {
			siteMetadata: {
				siteTitle: {
					ar: string;
				};
			};
		};
		allMarkdownRemark: {
			edges: Array<{
				node: {
					frontmatter: {
						title: string;
						description: string;
						date: string;
						updated_at: string;
					};
					fields: {
						slug: string;
					};
					excerpt: string;
				};
			}>;
		};
	};
}

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				siteTitle {
					ar
				}
			}
		}
		allMarkdownRemark(
			sort: {fields: [frontmatter___date], order: DESC}
			filter: {fields: {slug: {regex: "/^/ar//"}}}
		) {
			edges {
				node {
					excerpt
					fields {
						slug
					}
					frontmatter {
						date
						updated_at
						title
						lang
						description
					}
				}
			}
		}
	}
`;
